import styled from 'styled-components';
export const StyledIndicator = styled.div `
  margin-left: 1.5rem;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  & span + span {
    margin-left: 0.25rem;
  }
  height: 2.5rem;
  @media ${({ theme }) => theme.device.touch} {
    height: 2.75rem;
  }
`;
